import styled, { css } from "styled-components";
import { fontNormal, fontMedium, defaultSize } from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";

export const ListHolder = styled.div`
  background-color: ${buildColor("blue", "000")};
`;

export const ListWrapper = styled.div`
  background-color: ${buildColor("white", "100")};
  ${(props) =>
    !props.borderless &&
    css`
      border: 1px solid ${buildColor("grey", "300")};
      border-radius: 2px;
    `};
`;

export const MatchRaces = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  font-size: 12px;
  border-bottom: 1px solid ${buildColor("blue", "100")};
  background-color: ${buildColor("white", "100")};
`;

export const MatchRacesTitle = styled.h4`
  font-family: ${fontMedium};
  font-size: ${defaultSize};
  font-weight: 500;
  line-height: 19px;
  color: ${buildColor("grey", "900")};

  & span {
    font-family: ${fontNormal};
    font-weight: normal;
    line-height: 18px;
    color: ${buildColor("grey", "800")};
  }
`;

export const MatchRacesInfoContainer = styled.div`
  max-width: 85%;
  display: flex;
  flex-direction: column;
`;

export const CardWrapper = styled.div`
  padding: 12px 12px 0;
  background-color: ${buildColor("white", "100")};
  outline: none;
  ${({ isLast }) =>
    isLast
      ? css`
          border-bottom: 1px solid ${buildColor("blue", "100")};
          padding-bottom: 16px;
        `
      : css`
          &::after {
            padding-top: 12px;
            margin: 0 -12px;
            content: " ";
            display: block;
            border-bottom: 1px solid ${buildColor("blue", "100")};
          }
        `};
  ${({ hasSeparator }) =>
    hasSeparator &&
    css`
      margin-top: 8px;
      border-top: 1px solid ${buildColor("blue", "100")};
    `}
`;

export const EmptyStateWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  ${({ isMobile }) =>
    isMobile
      ? css`
          background-color: ${buildColor("white", "100")};

          & > div {
            width: 100%;
          }
        `
      : css`
          height: 40%;

          & div {
            background-color: transparent;

            & svg {
              background-color: ${buildColor("blue_accent", "300")};
              fill: ${buildColor("blue_accent", "600")};
              border-radius: 50%;
            }

            & button {
              background-color: ${buildColor("grey", "100")};
            }
          }
        `}
`;

export const RunnerInfoHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const MyStableRunnerInfo = styled.h3`
  font-family: ${({ theme }) => theme.fonts.bold};
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
`;

export const MyStableRunnerInfoDob = styled.h3`
  font-family: ${({ theme }) => theme.fonts.regular};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
`;
